
import AngleDown from "@/assets/svg/heroicons/angle-down.svg?inline";
import AngleUp from "@/assets/svg/heroicons/angle-up.svg?inline";

export default {
  components: {
    AngleDown,
    AngleUp,
  },
  props: {
    productDescription: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      readMoreToggle: true,
    };
  },
  computed: {
    readMoreActive() {
      if (this.productDescription) {
        return this.productDescription.length >= 1500;
      }
      return false;
    },
  },
  mounted() {
    this.$emit("success");
  },
  methods: {
    readMore() {
      const fadedText = document.querySelector(".fadedText");
      if (fadedText) {
        fadedText.classList.toggle("is-active");
        this.readMoreToggle = !this.readMoreToggle;
      }
    },
  },
};
